export default __webpack_public_path__ + "static/media/Payroll.322a2404.png";